<ng-container *ngIf="!state.loader; else logoLoader">
  <ag-grid-angular
    *ngIf="state.hasJobs; else noJobs"
    class="ag-theme-material-datos border-common rounded-sm"
    [columnDefs]="state.columnDefs"
    [gridOptions]="gridOptions"
    [rowData]="state.jobs"
    (gridReady)="onGridReady($event)"
  >
    <!-- (rowClicked)="onRowClicked($event)" -->
  </ag-grid-angular>

  <ng-template #noJobs>
    <div class="h-full w-full aligner flex-col text-typography-primary-old">
      <div class="empty-table">
        <img height="130" src="assets/images/not-available/no-data.svg" alt="No data" />
        <div class="empty-table-header">No jobs for this run</div>
        <div class="empty-table-body"></div>
      </div>
    </div>
  </ng-template>
</ng-container>

<ng-template #logoLoader>
  <y42-logo-loader [widthInPixel]="70" class="center-absolute"> </y42-logo-loader>
</ng-template>
